import React, { useRef } from "react";
import dayjs from "dayjs";
import logo from "../Images/Jayraj_logo.png"
import noimg from "../Images/noimg.jpg"

const HotelOrderDetailsModal = ({ booking, onClose }) => {
  const invoiceRef = useRef();

  if (!booking) return null;

  const {
    room,
    check_in,
    check_out,
    adults,
    children,
    infants,
    base_price,
    adult_price,
    child_price,
    extra_cost,
    total_price,
    status,
    created_at,
  } = booking;

  const hotels = booking?.room?.hotel;

  function calculateNights(check_in, check_out) {
    const inDate = new Date(check_in);
    const outDate = new Date(check_out);

    // Difference in milliseconds
    const diffTime = outDate - inDate;

    // Convert ms → days
    const nights = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return nights;
  }

  const nights = dayjs(check_in).diff(dayjs(check_in), "day");

const handlePrint = () => {
  const content = invoiceRef.current.innerHTML;

  const printWindow = window.open("", "_blank", "width=900,height=650");

  printWindow.document.write(`
    <html>
      <head>
        <title>Bus Ticket</title>

        <!-- Inherit fonts -->
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap" rel="stylesheet">

        <style>
          /* Base reset */
          * {
            box-sizing: border-box;
          }

          body {
            margin: 0;
            padding: 12mm;
            font-family: 'Inter', system-ui, sans-serif;
            background: #fff;
            color: #111;
          }

          /* ===== PDF DESIGN (same as app) ===== */
          ${document.querySelector("style")?.innerHTML || ""}

          /* Print settings */
          @page {
            size: A4;
            margin: 12mm;
          }

          /* Page break safety */
          .pdf-section,
          .passenger-item,
          .policy-item {
            page-break-inside: avoid;
            break-inside: avoid;
          }

          /* Remove non-pdf UI */
          .btn-print,
          .btn-close,
          .modal-close {
            display: none !important;
          }
        </style>
      </head>

      <body>
        <div class="pdf-ticket">
          ${content}
        </div>
      </body>
    </html>
  `);

  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};


  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <button onClick={onClose} style={closeBtnStyle}>✕</button>

        {/* INVOICE CONTENT */}
        <div ref={invoiceRef}>
          {/* HEADER */}
          <div style={{ display: "flex", alignItems: "center", marginBottom: 20 }}>
            <img
              src={
                logo
              }
              alt="Hotel"
              style={{ width: 140, height: 100, objectFit: "cover", borderRadius: 8 }}
            />
            <div style={{ flex: 1, textAlign: "center" }}>
              <h1>Hotel Booking Invoice</h1>
              <p><strong>Booking ID:</strong> #{booking.id}</p>
            </div>
          </div>

          {/* HOTEL DETAILS */}
          <div style={cardStyle}>
            <h2>Hotel Details</h2>
            <p><strong>{hotels?.name}</strong></p>
            <p>{hotels?.location}</p>
            <p><strong>Transport:</strong> {hotels?.transport}</p>
            <p>
              <strong>Check-in:</strong> {dayjs(check_in).format("D MMM YYYY, h:mm A")}
            </p>
            <p>
              <strong>Check-out:</strong> {dayjs(check_out).format("D MMM YYYY, h:mm A")}
            </p>
            <p><strong>Nights:</strong> {calculateNights(check_in, check_out)}</p>
          </div>

          {/* ROOM DETAILS */}
          <div style={cardStyle}>
            <h2>Room Details</h2>
            <p><strong>{room?.name}</strong></p>
            <p>Room Type: {room?.room_type}</p>
            <p>Package: {room?.package_type}</p>
            <p>Max Guests: {room?.max_guests}</p>
            <p>
              Food Included:
              {room?.breakfast ? " Breakfast" : ""}
              {room?.lunch ? ", Lunch" : ""}
              {room?.dinner ? ", Dinner" : ""}
            </p>
            <p>
              Meals:
              {room?.veg ? " Veg" : ""}
              {room?.non_veg ? ", Non-Veg" : ""}
            </p>
          </div>

          {/* GUEST DETAILS */}
          <div style={cardStyle}>
            <h2>Guest Summary</h2>
            <table>
              <tbody>
                <tr><td>Adults</td><td>{adults}</td></tr>
                <tr><td>Children</td><td>{children}</td></tr>
                <tr><td>Infants</td><td>{infants}</td></tr>
              </tbody>
            </table>
          </div>

          {/* PRICE BREAKDOWN */}
          <div style={cardStyle}>
            <h2>Price Breakdown</h2>
            <table>
              <tbody>
                <tr><td>Base Price</td><td className="right">₹{base_price}</td></tr>
                <tr><td>Extra Adult Price</td><td className="right">₹{adult_price}</td></tr>
                <tr><td> Extra Child Price</td><td className="right">₹{child_price}</td></tr>
                <tr><td>Extra Cost</td><td className="right">₹{extra_cost}</td></tr>
                <tr>
                  <th>Total Amount</th>
                  <th className="right">₹{total_price}</th>
                </tr>
              </tbody>
            </table>
          </div>

          {/* STATUS */}
          <div style={{ textAlign: "right", fontSize: 18 }}>
            Status: <span className="status">{status}</span>
            <br />
            Booking Date: {dayjs(created_at).format("D MMM YYYY")}
          </div>
        </div>

        {/* ACTION */}
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <button onClick={handlePrint} style={printBtnStyle}>
            🖨️ Print Invoice
          </button>
        </div>
      </div>
    </div>
  );
};

/* STYLES */
const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
};

const modalStyle = {
  background: "#fff",
  width: "85%",
  maxHeight: "90vh",
  overflowY: "auto",
  padding: 24,
  borderRadius: 10,
  position: "relative",
};

const closeBtnStyle = {
  position: "absolute",
  top: 10,
  right: 14,
  border: "none",
  background: "transparent",
  fontSize: 22,
  cursor: "pointer",
};

const cardStyle = {
  border: "1px solid #eee",
  padding: 16,
  borderRadius: 8,
  marginBottom: 16,
};

const printBtnStyle = {
  padding: "10px 20px",
  background: "#d48e0b",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  cursor: "pointer",
};

export default HotelOrderDetailsModal;
